// src/services/FamilyMemberApi.js
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL; // must end with /
const CUSTOMER_BASE_URL = `${API_URL}Customer`;
const MASTER_BASE_URL = `${API_URL}MasterAPI`;

// ------------------ Get All Relations ------------------
export const getAllRelations = async () => {
  try {
    const res = await axios.get(`${MASTER_BASE_URL}/GetAllRelations`);
    return res.data || []; // backend directly array return karta hai
  } catch (err) {
    console.error("🚨 Get All Relations Error:", err);
    return [];
  }
};

// ------------------ Insert Family Member ------------------
export const insertFamilyMember = async (formData, userId) => {
  try {
    const payload = new FormData();
    payload.append("Id", 0);
    payload.append("UserId", userId.toString());
    payload.append("FirstName", formData.firstName || "");
    payload.append("LastName", formData.lastName || "");
    payload.append("Age", Number(formData.age || 0));
    payload.append("RelationId", Number(formData.relationId || 0));
    payload.append("Gender", formData.gender || "");
    payload.append(
      "DateOfBirth",
      formData.dateOfBirth ? new Date(formData.dateOfBirth).toISOString() : ""
    );
    payload.append("HeightCM", Number(formData.heightCM || 0));
    payload.append("WeightKG", Number(formData.weightKG || 0));
    payload.append("BloodGroup", formData.bloodGroup || "");
    payload.append("Address", formData.address || "");
    payload.append("IsDefault", !!formData.isDefault);
    if (formData.photo) payload.append("UploadPhoto", formData.photo);

    const res = await axios.post(`${CUSTOMER_BASE_URL}/FamilyMemberInsert`, payload, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    console.error("🚨 Insert Family Member Error:", err);
    return { succeeded: false, message: "Network error" };
  }
};




// ------------------ Get Family Members By UserId ------------------
export const getFamilyMembersByUserId = async (userId) => {
  try {
    if (!userId) {
      const userData = JSON.parse(localStorage.getItem("medarphaUser"));
      userId = userData?.id || userData?.userId;
    }

    if (!userId) {
      console.error("❌ No userId found");
      return [];
    }

    const res = await axios.get(`${CUSTOMER_BASE_URL}/FamilyMemberGetByUserId?userId=${userId}`);
    const responseData = res.data;

    if (!responseData) return [];
    return Array.isArray(responseData) ? responseData : responseData.data || [];
  } catch (err) {
    console.error("🚨 Get Family Members Error:", err);
    return [];
  }
};
